import type { IndexerCitation, PriorArtCitations } from '../../schemas'

export const buildCitationsArray = (
  citations: IndexerCitation[],
  links: PriorArtCitations
): IndexerCitation[] => {
  const citationMap = new Map(
    citations.map((citation) => [citation.documentNumber, citation])
  )
  return links
    .map((link) => citationMap.get(link.documentNumber))
    .filter((citation): citation is IndexerCitation => !!citation)
}
